import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import AppointmentCalendar from '../Tasks/AppointmentsCalendar';
import BreadCrumb from '../BreadCrumb';


const pages = [
  { name: 'Service Advisor', to: '/vehicles', component: Link, current: false },
  { name: 'Scheduled Appointments', to: '/vehicles/appointments', component: Link, current: true },
];

const JobAppointments = () => {
  return (
    <>
      <BreadCrumb pages={pages} />

      {/* Gradient Background */}
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50 py-8">
        <div className="container mx-auto px-4">

          {/* Page Header */}
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-3 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl shadow-lg">
                <CalendarDaysIcon className="h-8 w-8 text-white" />
              </div>
              <div>
                <h1 className="text-4xl font-black text-gray-900">Scheduled Appointments</h1>
                <p className="text-gray-600 mt-1">Manage and track service appointments</p>
              </div>
            </div>
          </div>

          {/* Appointment Calendar with Modern Styling */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="p-6">
              <AppointmentCalendar />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobAppointments;
